<template>
  <slide-x-right-transition>
    <div>
      <div class="content v-form">
        <div class="orders-link-box">
          <div class="link-group">
            <div v-for="(menu, mi) in menus" :key="mi">
              <p class="title">
                <a @click="route(menu.subMenus[0].subLink, menu.title, menu.subMenus[0].subTitle)"
                   href="javascript:void(0)">{{ menu.title }}</a>
              </p>
              <ul class="link-ul">
                <li v-for="(subMenu, subi) in menu.subMenus" :key="subi">
                  <a @click="route(subMenu.subLink, menu.title, subMenu.subTitle)"
                     href="javascript:void(0)">{{ subMenu.subTitle }}</a><span
                    class="num"></span><i class="icon-right"></i>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!--我的付款账号-->
        <div class="form-container" id="pay-account">
          <div class="form-head">
            <p class="title">{{ title }}</p>
            <p class="des">{{ subTitle }}</p>
          </div>
          <div class="form">
            <keep-alive>
              <router-view/>
            </keep-alive>
          </div>
        </div>
      </div>
    </div>
  </slide-x-right-transition>
</template>

<script>
import '../assets/styles/setting.css';
import '../assets/styles/setting-m.css';

export default {
  data () {
    return {
      title: '',
      subTitle: '',
      menus: [{
        title: '个人信息',
        subMenus: [{
          subTitle: '账户设置',
          subLink: '/account'
        }, {
          subTitle: '我的付款账号',
          subLink: '/pay-account'
        }]
      }, {
        title: '服务器',
        subMenus: [{
          subTitle: '我的服务器',
          subLink: '/server'
        }, {
          subTitle: '我的域名',
          subLink: '/domain'
        }]
      }, {
        title: '系统设置',
        subMenus: [{
          subTitle: '客户管理',
          subLink: '/customer'
        }]
      }]
    }
  },
  methods: {
    route (link, title, subTitle) {
      if (this.$route.path !== link) {
        this.$router.push(link)
        this.title = title
        this.subTitle = subTitle
      }
    },
    setTitle () {
      let path = this.$route.path;
      let subMenu;
      let menu = this.menus.find(menu => {
        subMenu = menu.subMenus.find(subMenu => {
          return path === subMenu.subLink
        })
        return subMenu
      })
      this.title = menu.title
      this.subTitle = subMenu.subTitle
    }
  },
  mounted () {
    window.$setting = this;
    this.setTitle()
  },
  provide () {
    return {
      componentSetting: this
    }
  }
}
</script>

<style scoped>
.btn {
  padding: 7px 13px;
  margin-right: 10px;
  display: inline-block;
}

.form-head {
  margin-bottom: 20px;
}
</style>
